import * as vp from 'vopay';

type UpdateWebhookRows = {
  label: vp.UpdateWebhookLabel;
  id: vp.UpdateWebhookId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const buildUpdateWebhookRows = (): UpdateWebhookRows[] => [
  {
    label: vp.UpdateWebhookLabel.AccountStatusWebHookURL,
    id: vp.UpdateWebhookId.AccountStatusWebHookURL,
    preset: 'text',
    required: true,
  },
];
export default buildUpdateWebhookRows;
